import React from "react";
import { useTranslation } from "react-i18next";
export default function Articles() {
  const { t, i18n } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 100,
      }}
    >
      <a style={{ fontSize: 25, fontWeight: "500" }}>{t("profile.Articles")}</a>
    </div>
  );
}
